<template>
	<VInputMask
		ref="company-nip"
		:value="company.additionalAttributes.nip.value"
		:label="company.additionalAttributes.nip.name"
		layout="vertical"
		:tokens="{
        '#': { pattern: /\d/ },
      }"
		mask="###-###-##-##"
		:disabled="readOnly"
	/>

	<VInputMask
		ref="company-lei-input"
		:value="company.additionalAttributes.lei.value"
		:label="company.additionalAttributes.lei.name"
		layout="vertical"
		:tokens="{
        '#': { pattern: /\d/ },
      }"
		mask="####-##-############-##"
		:validate-method="PlUtils.validateLEI"
		:disabled="readOnly"
	/>
</template>

<script>

import PlUtils from '@/core/utils/regional/PlUtils'
import Company from "@/domains/Companies/Company.js";

export default {
	name:   'PLAdditionalAttributes',

	props: {
    company: {
      type:     Company,
      required: true
    },
		readOnly: {
			type: Boolean,
			default: false,
		}
	},

	data() {
		return {
			PlUtils,
		}
	}
};
</script>
